/**
 * load Localytics into page
 * (from http://docs.localytics.com/dev/web.html#getting-started-web)
 * changing anything in this function seems to just break localytics
 */

export const initializeLocalytics = (config: Object) => {
  const { LOCALYTICS_APP_KEY } = config;

  /* eslint-disable */
  +function (l, y, t, i, c, s) {
    l[ 'LocalyticsGlobal' ] = i;
    l[ i ] = function () {
      (l[ i ].q = l[ i ].q || []).push(arguments)
    };
    l[ i ].t = +new Date;
    (s = y.createElement(t)).type = 'text/javascript';
    s.src = '//web.localytics.com/v3/localytics.min.js';
    (c = y.getElementsByTagName(t)[ 0 ]).parentNode.insertBefore(s, c);
    ll('init', LOCALYTICS_APP_KEY, {} /* Options */);
  }(window, document, 'script', 'll');
  /* eslint-enable*/
};

export const tagEvent = (name: string, getOptions: Function) => {
  /* eslint-disable no-console */
  try {
    console.info(`Localytics-TagEvent: ${name}`, getOptions());
    ll('tagEvent', name, getOptions());
  } catch (e) {
    console.error(e);
  }
  /* eslint-enable no-console */
};

export const tagStatColumns = (name: string, statColumns: Array) => {
  statColumns.forEach((stats) => {
    if (stats === 'title') {
      return;
    }
    tagEvent(`STATS: ${name}`, () => ({ stats: stats.key || stats }));
  });
};

export const tagScreen = (screenName: string) => {
  /* eslint-disable no-console */
  try {
    console.info(`Localytics-TagScreen: ${screenName}`);
    ll('tagScreen', screenName);
  } catch (e) {
    console.error(e);
  }
  /* eslint-enable no-console */
};